import { AxiosResponse } from "axios";
import { axiosConfig } from "../../config/api/configApi";

export const moocPolicyGetAllByFilter : (data: any) => Promise<AxiosResponse<any>> = (data) => {
    return axiosConfig.post(`v2/open-api/mooc-policy/get-all-by-filter`, data);
} 